var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.249 19.4993V14.9992C14.249 14.8003 14.1699 14.6095 14.0293 14.4689C13.8886 14.3282 13.6979 14.2492 13.499 14.2492H10.499C10.3001 14.2492 10.1093 14.3282 9.96863 14.4689C9.82798 14.6095 9.74896 14.8003 9.74896 14.9992V19.4993C9.74896 19.6982 9.66996 19.889 9.52933 20.0296C9.38869 20.1703 9.19795 20.2493 8.99906 20.2493L4.49961 20.2499C4.40111 20.2499 4.30357 20.2305 4.21256 20.1928C4.12156 20.1551 4.03887 20.0999 3.96921 20.0303C3.89956 19.9606 3.84431 19.8779 3.80661 19.7869C3.76891 19.6959 3.74951 19.5984 3.74951 19.4999V10.8317C3.74951 10.7272 3.77135 10.6239 3.81361 10.5283C3.85588 10.4328 3.91765 10.3471 3.99496 10.2768L11.4944 3.45794C11.6325 3.33241 11.8124 3.26285 11.999 3.26285C12.1856 3.26284 12.3655 3.33239 12.5035 3.4579L20.004 10.2768C20.0813 10.3471 20.1431 10.4328 20.1854 10.5284C20.2277 10.6239 20.2495 10.7273 20.2495 10.8318V19.4999C20.2495 19.5984 20.2301 19.6959 20.1924 19.7869C20.1547 19.8779 20.0995 19.9606 20.0298 20.0303C19.9602 20.0999 19.8775 20.1552 19.7865 20.1928C19.6955 20.2305 19.5979 20.2499 19.4994 20.2499L14.9989 20.2493C14.8 20.2493 14.6092 20.1703 14.4686 20.0296C14.328 19.889 14.249 19.6982 14.249 19.4993V19.4993Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.082b5ab0a97af661886ecd2d73d982f6.svg";
export { ForwardRef as ReactComponent };